<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 31px;
        font-weight: bold;
        color: #05523e;
        padding-top: 30px;
      "
    >
      Edit Employee
    </v-card-title>
    <div style="margin: 20px 8% auto">
      <div class="rows">
        <span>Cashier Id</span>
        <v-text-field class="textField" v-model="cashierId" outlined readonly />
      </div>
      <div class="rows">
        <span>ID</span>
        <v-text-field class="textField" v-model="Id" outlined readonly />
      </div>
      <div class="rows" style="height: 57px">
        <span
          >Email
          <p style="color: red; font-size: 15px">{{ this.dupEmail }}</p></span
        >
        <v-text-field
          class="textField"
          v-model="email"
          :rules="[rules.required, rules.emailMatch]"
          outlined
          @input="emailDuplicateCheck"
        />
      </div>
      <div class="rows">
        <span>Permission</span>
        <v-select
          :items="items"
          item-text="label"
          item-value="value"
          class="textField"
          dense
          v-model="$store.state.account.employeeOne.Permission"
        ></v-select>
      </div>
      <div class="rows" style="height: 40px">
        <span></span>
        <div>
          <v-btn
            @click="showPwInput"
            color="#05523E"
            style="color: white; width: 190px"
          >
            Edit Password
          </v-btn>
        </div>
      </div>
      <div v-if="showPw" class="rows" style="margin-top: 20px">
        <span>New Password</span>
        <v-text-field
          class="textField"
          v-model="password"
          outlined
          :rules="[rules.min, rules.required]"
          type="password"
        />
      </div>

      <div v-if="showPw" class="rows">
        <span>Re-Password</span>
        <v-text-field
          class="textField"
          v-model="rePassword"
          outlined
          :rules="[rules.pwMatch, rules.required]"
          type="password"
        />
      </div>
    </div>
    <v-card-actions style="justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="closeModal"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="validation"
        >Edit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { UPDATEADMIN } from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      userId: this.$store.state.account.employeeOne._id,
      Id: this.$store.state.account.employeeOne.ID,
      email: this.$store.state.account.employeeOne.Email,
      dupEmail: "",
      cashierId: this.$store.state.account.employeeOne.Cashier_ID,
      showPw: false,
      password: "",
      permission: this.$store.state.account.employeeOne.Permission,
      rePassword: "",
      items: [
        { label: "Employee", value: 0 },
        { label: "Admin", value: 1 },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
        pwMatch: () =>
          this.password == this.rePassword || "Passwords do not match",
        emailMatch: (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      },
    };
  },
  methods: {
    showPwInput() {
      this.showPw = !this.showPw;
    },
    async emailDuplicateCheck() {
      try {
        if (
          await this.$store.dispatch("account/getAdminEmailForDuplicate", {
            Column: "Email",
            Search: this.email,
          })
        ) {
          this.dupEmail = "Duplicate Email";
        } else {
          this.dupEmail = "";
        }
      } catch (err) {
        console.error(err);
      }
    },
    async validation() {
      try {
        const req = { _id: this.userId };

        // email valid
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email))
          return;
        req.Email = this.email;

        // password valid
        if (this.showPw) {
          if (
            this.password.length < 6 ||
            this.rePassword.length < 6 ||
            this.password !== this.rePassword
          )
            return;
          req.PW = this.password;
        }

        if (!this.Id) {
          this.$store.commit("common/snackErrOn", {
            text: "Please input ID",
          });
        }

        req.Permission = this.$store.state.account.employeeOne.Permission;

        this.editEmployee(req);
      } catch (err) {
        console.error(err);
      }
    },
    async editEmployee(req) {
      try {
        const updateResult = await runGqlMutation(UPDATEADMIN, req);
        if (
          updateResult.message === undefined &&
          updateResult.updateAdmin.ResultCount !== 0
        ) {
          await this.$emit("getEmployeeList");
          this.$store.commit("common/snackOn", {
            text: "Edit Employee Success!",
          });
          this.closeModal();
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Edit Employee Failed!",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async closeModal() {
      try {
        this.showPw = false;
        this.$store.commit("common/changeEditEmployeeModalView");
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scope>
.rows {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  height: 65px;
}
.rows > span {
  width: 185px;
  font-size: 19px;
  font-weight: 500;
}
.textField {
  max-width: 190px;
  min-width: 190px;
}
</style>
